import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bangloreinternatinalairportcorporate() {



  const cardData =
  {
    keyword: ' Bangalore International Airport Corporate Cab Service',
    heading: 'Pune Corporate Cars India Private Limited: Bangalore International Airport Corporate Cab Service',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Bangalore International Airport Corporate Cab Service, ensuring smooth and timely transportation for corporate travelers, employees, clients, and top executives. Our fleet of executive sedans, SUVs, and premium vehicles guarantees safe, comfortable, and hassle-free airport transfers for arrivals, departures, and connecting business travel. With experienced chauffeurs, real-time flight coordination, 24/7 availability, and well-maintained vehicles, we deliver punctual and efficient mobility solutions. Pune Corporate Cars India Private Limited ensures a premium and dependable corporate airport travel experience for businesses operating in and around Bangalore International Airport.',

    top: 'Top Places to Visit in Bangalore with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace, built in the 19th century, is inspired by England’s Windsor Castle and showcases Tudor-style architecture with fortified towers, elegant woodwork, and sprawling gardens. Visitors can explore the royal interiors, vintage furniture, and photo galleries. The palace also hosts cultural events, music concerts, and exhibitions, making it a hub for history and heritage enthusiasts."
  },
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden spans 240 acres and is famous for its diverse flora, centuries-old trees, and iconic glasshouse. It hosts biannual flower shows attracting visitors from across the city. The garden offers walking paths, serene lakes, and picturesque landscapes, making it ideal for nature lovers, photographers, and families seeking relaxation amidst greenery."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park is a 300-acre urban oasis in central Bangalore featuring lush greenery, walking trails, jogging paths, and playgrounds. It houses statues, government buildings, and botanical features, creating a perfect blend of nature and culture. The park is a popular spot for morning walks, family outings, photography, and leisurely strolls."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is an iconic government building in Bangalore known for its Neo-Dravidian architectural style. It features grand pillars, intricate stone carvings, and massive domes. Though entry is restricted, the majestic facade and surrounding viewpoints provide excellent photo opportunities, and it stands as a symbol of Karnataka’s political and cultural heritage."
  },
  {
    "title": "ISKCON Temple Bangalore",
    "description": "The ISKCON Temple in Bangalore is a spiritual and cultural center dedicated to Lord Krishna. The temple features traditional architecture, vibrant murals, and beautifully landscaped gardens. Visitors can participate in devotional ceremonies, cultural programs, and enjoy vegetarian meals at the temple’s food court, making it a peaceful escape for meditation and spiritual learning."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is one of Bangalore’s busiest shopping destinations, offering clothing, footwear, jewelry, and street food. Locals and tourists flock here for shopping, bargain hunting, and exploring vibrant street markets. The lively atmosphere and colorful storefronts make it a must-visit for retail enthusiasts and urban explorers."
  },
  {
    "title": "Bannerghatta National Park",
    "description": "Bannerghatta National Park is a major wildlife destination near Bangalore, featuring a zoo, butterfly park, safari rides, and trekking trails. Visitors can see lions, tigers, elephants, and other animals in naturalistic habitats. The park is ideal for families, wildlife enthusiasts, and students seeking educational and recreational experiences close to the city."
  },
  {
    "title": "Ulsoor Lake",
    "description": "Ulsoor Lake is a scenic water body in central Bangalore, popular for boating, photography, and evening strolls. Surrounded by greenery and small islands, it provides a serene spot for relaxation, picnics, and spending quality time with family or friends amidst the city’s bustle."
  },
  {
    "title": "Nandi Hills",
    "description": "Nandi Hills, located on the outskirts of Bangalore, is a scenic hill station known for breathtaking sunrise views, trekking trails, and historical sites like Tipu Sultan’s Summer Palace. The cool climate, lush landscapes, and panoramic vistas make it a favorite spot for nature lovers, photographers, and adventure seekers looking for a refreshing escape."
  },
  {
    "title": "Wonderla Amusement Park",
    "description": "Wonderla, located near Bangalore, is a top amusement park offering thrilling rides, water slides, and family entertainment zones. It is ideal for a fun-filled day with friends and family, featuring safe rides, adventure zones, and well-maintained facilities. Seasonal events and themed attractions make it a popular destination for both locals and tourists seeking excitement and leisure."
  }
],


"services": [
{
"name": "Airport Corporate Taxi Bangalore",
"description": "Airport Corporate Taxi Bangalore provides professional airport transportation solutions for corporate clients, executives, and employees. The service features well-maintained sedans and SUVs, trained chauffeurs, real-time tracking, and punctual pick-up/drop-off schedules. Designed for business travelers and staff commuting to offices from the airport, it ensures a comfortable, reliable, and efficient travel experience, supporting multi-shift operations and seamless airport connectivity across Bangalore."
},
{
"name": "Airport Employee Shuttle Bangalore",
"description": "Airport Employee Shuttle Bangalore delivers high-capacity shuttle services for employees commuting between offices and the airport. Using air-conditioned minibuses and vans, it provides structured routes, optimized trip clustering, and real-time GPS tracking. The service ensures dependable, safe, and organized shuttle operations for corporate staff, accommodating multiple shifts and large teams traveling along key business corridors of Bangalore."
},
{
"name": "Airport Pickup Drop Office Staff",
"description": "Airport Pickup Drop Office Staff offers dedicated transport for employees traveling between the airport and their workplaces. The service includes fixed and flexible routes, professional drivers, real-time vehicle monitoring, and timely scheduling. It is designed to ensure seamless last-mile connectivity, safe commuting, and punctual travel for corporate staff, enhancing efficiency for businesses relying on airport-based employee movements."
},
{
"name": "Business Airport Cab Bangalore",
"description": "Business Airport Cab Bangalore provides premium corporate transportation for executives, clients, and business travelers. With luxury sedans and SUVs, GPS-enabled tracking, and experienced chauffeurs, it ensures timely airport transfers, inter-office visits, and client meetings. The service combines comfort, professionalism, and reliability, supporting both short-distance commutes and long-distance airport trips across Bangalore."
},
{
"name": "Corporate Airport Transfer Bangalore",
"description": "Corporate Airport Transfer Bangalore offers end-to-end airport mobility solutions for companies, including staff transfers, executive commutes, and client transportation. The service includes vehicle fleet management, professional driver coordination, GPS monitoring, and multi-shift support, ensuring secure, punctual, and efficient travel between offices and the airport, tailored for corporate clients seeking reliable airport connectivity."
},
{
"name": "Airport Sedan Cab",
"description": "Airport Sedan Cab delivers executive-level sedans for airport transfers, office commutes, and client travel. Each vehicle is well-maintained, equipped with modern amenities, and operated by professional chauffeurs, ensuring comfort, safety, and punctuality for corporate passengers traveling to and from Bangalore airport."
},
{
"name": "Airport SUV Cab",
"description": "Airport SUV Cab provides spacious, high-comfort SUVs ideal for team travel, VIP transfers, and long-distance airport trips. Equipped with GPS tracking, safety protocols, and professional drivers, the service ensures reliable, safe, and premium travel experience for employees and executives commuting between Bangalore airport and corporate offices."
},
{
"name": "Monthly Airport Cab",
"description": "Monthly Airport Cab offers long-term corporate cab services for staff and executives requiring regular airport transfers. The service includes dedicated vehicles, professional drivers, flexible monthly plans, real-time tracking, and multi-shift support, ensuring uninterrupted, safe, and cost-effective airport commute solutions for organizations in Bangalore."
},
{
"name": "Best Airport Corporate Cab Bangalore",
"description": "Best Airport Corporate Cab Bangalore provides top-tier airport transport services for corporate clients, senior management, and business visitors. The service features premium vehicles, highly trained chauffeurs, GPS-enabled tracking, and multi-shift support, ensuring reliable, safe, and professional travel between Bangalore airport and offices, hotels, and client sites."
},
{
"name": "Affordable Airport Shuttle",
"description": "Affordable Airport Shuttle delivers cost-effective corporate airport transport without compromising on safety, comfort, or reliability. Designed for companies with budget-conscious operations, it provides sedans, SUVs, and shuttle vehicles with trained drivers, efficient routes, real-time tracking, and timely pick-ups, ensuring smooth and economical staff and executive mobility between the airport and offices."
},
{
"name": "Airport Chauffeur Service",
"description": "Airport Chauffeur Service offers professional driver services for airport transfers, executive travel, and business commutes. The service ensures punctual pick-ups, comfortable rides, real-time tracking, and strict adherence to safety protocols. It caters to corporate executives, VIP clients, and staff requiring reliable and hassle-free airport transportation in Bangalore."
},
{
"name": "Executive Airport Taxi",
"description": "Executive Airport Taxi provides premium airport transport solutions for managers, senior executives, and business travelers. Featuring well-maintained sedans and SUVs, professional chauffeurs, and GPS-enabled tracking, it ensures comfortable, punctual, and secure transfers between Bangalore airport and corporate offices, hotels, and client locations."
},
{
"name": "Staff Airport Transport",
"description": "Staff Airport Transport delivers structured employee commute services for airport transfers, ensuring safe, timely, and reliable pick-up and drop operations. The service integrates route planning, GPS tracking, professional drivers, and multi-shift support, making it ideal for organizations with large teams traveling to and from Bangalore airport."
},
{
"name": "Company Airport Cab",
"description": "Company Airport Cab provides end-to-end airport transport solutions for corporate fleets. The service includes vehicle scheduling, professional driver management, GPS monitoring, and multi-shift support. It ensures safe, timely, and comfortable transfers for employees, executives, and visitors traveling between Bangalore airport and company offices."
},
{
"name": "Airport Fleet Service Bangalore",
"description": "Airport Fleet Service Bangalore offers comprehensive fleet management for corporate airport transport. It includes sedans, SUVs, and shuttle vehicles with professional drivers, maintenance, GPS-enabled monitoring, and route optimization. The service ensures reliable, safe, and efficient airport mobility solutions for organizations requiring daily or long-term staff and executive transport to and from Bangalore airport."
}
],

"tableData": [
["Airport Corporate Taxi Bangalore", "Airport Employee Shuttle Bangalore"],
["Airport Pickup Drop Office Staff", "Business Airport Cab Bangalore"],
["Corporate Airport Transfer Bangalore", "Airport Sedan Cab"],
["Airport SUV Cab", "Monthly Airport Cab"],
["Best Airport Corporate Cab Bangalore", "Affordable Airport Shuttle"],
["Airport Chauffeur Service", "Executive Airport Taxi"],
["Staff Airport Transport", "Company Airport Cab"],
["Airport Fleet Service Bangalore", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Bangalore International Airport Corporate Cab Service",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services for Bangalore International Airport, ensuring smooth and timely transfers for employees, executives, and business travelers."
  },
  {
    "WhyChooseheading": "Punctual Airport Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure on-time airport pickups and drop-offs, helping corporate travelers reach terminals for departures or arrivals without any stress or delay."
  },
  {
    "WhyChooseheading": "Professional & Experienced Chauffeurs",
    "WhyChoosedescription": "Our skilled drivers are trained in corporate protocols, providing safe, courteous, and disciplined travel for airport transfers."
  },
  {
    "WhyChooseheading": "Premium & Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, luxury cars, tempo travellers, and minibuses—sanitized, serviced, and maintained for comfortable and reliable airport travel."
  },
  {
    "WhyChooseheading": "Customized Airport Travel Packages",
    "WhyChoosedescription": "We offer tailored corporate cab rental plans for airport transfers, ideal for business teams, executives, and visiting clients."
  },
  {
    "WhyChooseheading": "24/7 Airport Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, flight-based adjustments, and emergency airport travel needs."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are sanitized regularly and equipped with modern safety features, ensuring secure and hygienic airport transportation."
  },
  {
    "WhyChooseheading": "Seamless Booking & Coordination",
    "WhyChoosedescription": "Corporate airport travel is streamlined through our easy booking process and efficient coordination, ensuring hassle-free transfers for employees and executives."
  }
]

































  }

const faqData = [
  {
    question: 'Do you provide corporate cab services to and from Bangalore International Airport?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate cab services for airport pickups and drops at Bangalore International Airport (Kempegowda International Airport).',
  },
  {
    question: 'Are your airport corporate cab services available 24×7?',
    answer: 'Absolutely. We operate 24×7 to ensure timely airport transfers for business travelers, employees, and executives.',
  },
  {
    question: 'What types of vehicles do you offer for airport corporate travel?',
    answer: 'We offer sedans, hatchbacks, SUVs, luxury cars, Innova Crysta, and tempo travellers based on corporate travel requirements.',
  },
  {
    question: 'Do you provide meet-and-greet services at Bangalore Airport?',
    answer: 'Yes, we offer professional meet-and-greet services for corporate guests, VIPs, and business delegates.',
  },
  {
    question: 'How early should we book a corporate airport cab?',
    answer: 'You can book anytime, but we recommend scheduling pickups at least 2 hours in advance for smooth coordination.',
  },
  {
    question: 'Do you offer corporate contracts for regular airport transfers?',
    answer: 'Yes, we provide monthly and annual corporate airport travel contracts with transparent and flexible pricing.',
  },
  {
    question: 'Are your airport cabs tracked and monitored?',
    answer: 'Yes, all vehicles are GPS-enabled with live tracking, and our team monitors every trip for safety and punctuality.',
  },
  {
    question: 'Do you provide cab services for corporate groups arriving at Bangalore Airport?',
    answer: 'Yes, we offer coordinated group pickups, event travel support, and dedicated fleet arrangements for corporate teams.',
  },
  {
    question: 'What payment methods are accepted for airport corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aditya Menon',
    feedback: 'Very efficient airport corporate cab service. The pickup was on time, and the vehicle was extremely comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shalini Verghese',
    feedback: 'Highly reliable service for our business travelers. Smooth coordination and professional drivers every time.',
    rating: 5,
  },
];




































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bangalore International Airport Corporate Cab Service",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-bangalore-airport.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited offers premium corporate cab services at Bangalore International Airport, including airport employee shuttles, office pickup & drop, business and executive airport cabs, monthly cab plans, outstation trips, and corporate fleet solutions for companies and airport staff transport.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/bangalore-airport-corporate-cab-service"
  }
};










  return (
    <div>
<Helmet>
  <title>Bangalore International Airport Corporate Cab Service | Employee & Business Transport</title>

  <meta
    name="description"
    content="Premium corporate cab services at Bangalore International Airport including employee shuttles, office pickup & drop, business and executive airport cabs, monthly cab plans, and corporate fleet solutions."
  />

  <meta
    name="keywords"
    content="Airport Corporate Taxi Bangalore, Airport Employee Shuttle Bangalore, Airport Pickup Drop Office Staff, Business Airport Cab Bangalore, Corporate Airport Transfer Bangalore, Airport Sedan Cab, Airport SUV Cab, Monthly Airport Cab, Best Airport Corporate Cab Bangalore, Affordable Airport Shuttle, Airport Chauffeur Service, Executive Airport Taxi, Staff Airport Transport, Company Airport Cab, Airport Fleet Service Bangalore"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/65.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bangloreinternatinalairportcorporate;